import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Panel from '../../../components/Panel';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody, Badge} from 'reactstrap';
import * as http from '../../../modules/http';
import EditHandleNameForm from './EditHandleNameForm';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    admin_open_hname_update_form,
    admin_hname_delete,
    fetchAdminDataIfNeeded
} from '../../../redux/actions/AdminActions';
import Modal from '../../../components/Modal';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import * as TextManager from "../../../modules/languages/TextManager";



class CustomTooltip extends PureComponent {
    render() {
        const {active} = this.props;

        if (active) {
            const {payload} = this.props;

            if (payload != null) {
                return (
                    <div className="dashboard__total-tooltip">
                        <p className="label">{`$${payload[0].value}`}</p>
                    </div>
                );
            }
            else {
                return (<span></span>)
            }
        }

        return null;
    }
}

const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);

class HandleNameTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 10
        };
    }

    editStore(offer) {

        if (offer.id === this.state.selectedID && this.state.windowType === 2) {
            this.setState({selectedID: 0, windowType: 0});
        }
        else {
            this.props.dispatch(admin_open_hname_update_form(offer));
            this.setState({
                selectedID: offer.id, windowType: 2, error: false,
            });
        }
    }

    addStore() {

        const store = {id: 0, handleName: ''};
        this.props.dispatch(admin_open_hname_update_form(store));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    }

    deleteHandleName = (customer) => {
        //abc
        http.postToServer(
            'handle_name/delete?id=' + customer.id,
            {},
            (response) => {
                this.props.dispatch(admin_hname_delete(customer.id));
            },
            (response) => {
                console.log('error delete handle_name');
            }
        );

    };

    getRow(store, index) {

        return (

            <React.Fragment key={store.id}>

                <tr key={store.id}>

                    <td>
                        <Modal color='danger' title='Are you sure!'
                               approve={() => this.deleteHandleName(store)}
                               message={'Delete Customer ' + store.handleName + '?'}>
                            <Button color='danger' size='sm' onClick={(e) => e.preventDefault()}
                                    style={{padding: "0px 15px"}}>
                                <FontAwesome name='times'/>
                            </Button>

                        </Modal>
                    </td>

                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                                onClick={() => this.editStore(store)}>{TextManager.getCurrentTextResource().Text.edit}</Button>
                    </td>

                    <td>{store.handleName}</td>
                    <td>{store.id}</td>

                </tr>

                {this.state.windowType === 2 && store.id === this.state.selectedID &&
                <tr key={store.id + 2000}>
                    <td colSpan="7">
                        <EditHandleNameForm onClose={() => this.editStore(store)}/>
                    </td>
                </tr>
                }
            </React.Fragment>
        );
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    render() {
        const {rowsPerPage, page} = this.state;

       //console.log(this.props.handleName);

        let rows = this.props.handleName.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((store, index) =>
            this.getRow(store)
        );


        var isAdding = this.state.windowType === 2 && this.state.selectedID === 0;

        return (
            <Card>
                <CardBody>
                    {isAdding &&
                    <EditHandleNameForm onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                    }

                    {!isAdding && <div className="card__title">
                        <h5 className="bold-text"
                            style={{float: 'right'}}>שם משווק</h5>
                    </div>}

                    {!isAdding &&
                    <span>
                        <Table responsive className='table--bordered'>
                            <thead>
                            <tr>

                                <th></th>
                                <th>
                                    {<Button color='primary' size='sm'
                                             style={{padding: "0px 15px", margin: "0px"}}
                                             onClick={() => this.addStore()}>
                                        <FontAwesome name='plus-square' style={{marginLeft: "5px"}}/>
                                    </Button>}

                                </th>

                                <th>שם משווק</th>
                                <th>{TextManager.getCurrentTextResource().Customers.id}</th>

                                <th></th>


                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>
                        <Row>
                            <TablePagination
                                labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={this.props.handleName.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActionsWrapped}
                            />
                        </Row>
                    </span>
                    }
                </CardBody>
            </Card>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        //handleName: state.admin.handleName,
        userData: state.userData,
        utilsData: state.utilsData
    };
};

export default withRouter(connect(mapStateToProps)(HandleNameTable))